import { render, staticRenderFns } from "./AdvertisementVideo.vue?vue&type=template&id=047798b8&scoped=true"
import script from "./AdvertisementVideo.vue?vue&type=script&lang=js"
export * from "./AdvertisementVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047798b8",
  null
  
)

export default component.exports